import * as React from "react";
import { cn } from "../lib/utils";

interface PageHeaderProps {
  title: string;
  // ReactNode (not just string) so pages can render structured
  // summaries in the description slot — e.g. the audit page's
  // "7 events — 5 success, 1 failure, 1 denied" breakdown. Plain
  // strings still work, so existing callers are unaffected.
  description?: React.ReactNode;
  actions?: React.ReactNode;
  back?: React.ReactNode;
  className?: string;
}

export function PageHeader({ title, description, actions, back, className }: PageHeaderProps) {
  return (
    <div
      className={cn(
        "flex flex-col items-start justify-between gap-4 border-b border-border/70 pb-4 sm:flex-row",
        className,
      )}
    >
      <div className="min-w-0">
        {back && <div className="mb-1.5">{back}</div>}
        <h1 className="text-2xl font-bold tracking-[-0.025em] text-balance">{title}</h1>
        {description && (
          // Cap the description at a reading measure (~75ch) so page explainers
          // don't run edge-to-edge at the 1280px content width — long lines are
          // the "compressed text with whitespace" readability issue. Data tables
          // below still use the full width.
          <p className="mt-1 max-w-2xl text-sm leading-relaxed text-muted-foreground">
            {description}
          </p>
        )}
      </div>
      {actions && (
        <div className="flex max-w-full flex-wrap items-center gap-2 sm:flex-shrink-0 sm:mt-0.5">
          {actions}
        </div>
      )}
    </div>
  );
}
